import { useState } from 'react';
import { channels, communityStats } from '@/mocks/home';
import Reveal from '@/components/feature/Reveal';

export default function CommunityPanel() {
  const [active, setActive] = useState('');

  return (
    <section id="channels" className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <div className="grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 md:grid-cols-4">
            {communityStats.map((stat) => (
              <div key={stat.id} className="bg-background-50 px-4 py-5 md:px-5 md:py-6">
                <p className="font-heading text-2xl font-bold text-foreground-950 md:text-[28px]">{stat.value}</p>
                <p className="mt-1 text-xs text-foreground-600">{stat.label}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-10 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="text-xs font-medium tracking-widest text-primary-700">CHANNELS / 讨论版块</span>
              <h3 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                挑一个版块，从你最熟的方向切进去
              </h3>
              <p className="mt-2 max-w-2xl text-sm text-foreground-600">
                影视、综艺、消费、现场……每个版块都有固定的整理习惯，进去就知道大家在聊什么。
              </p>
            </div>
            <span className="w-fit rounded-full border border-background-300 px-3 py-1 text-xs text-foreground-600">
              按话题量排序
            </span>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
            {channels.map((channel) => {
              const isActive = active === channel.id;
              return (
                <button
                  key={channel.id}
                  type="button"
                  onClick={() => setActive(isActive ? '' : channel.id)}
                  className={`flex cursor-pointer items-center gap-3 rounded-lg border p-4 text-left transition-colors ${
                    isActive
                      ? 'border-secondary-400 bg-secondary-100'
                      : 'border-background-200 bg-background-100 hover:border-secondary-300'
                  }`}
                >
                  <span
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md ${
                      isActive ? 'bg-secondary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                    }`}
                  >
                    <i className={`${channel.icon} text-base`} />
                  </span>
                  <span className="min-w-0">
                    <span className="block truncate text-sm font-medium text-foreground-900">{channel.name}</span>
                    <span className="mt-0.5 block text-xs text-foreground-500">{channel.count} 条讨论</span>
                  </span>
                </button>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}